module.exports = __webpack_public_path__ + "static/media/icon4.8c16b46e.png";